module.exports = __webpack_public_path__ + "static/base-tab-240cd83215ad5e26b05a508f513b165d.png";